// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"455":"9fa41fb3","977":"e762ed05"}[chunkId] + ".chunk.js");